import proxy from "api/proxy";
import { getStorage } from "store/local";

const TYPES_LEADS = [
  { id: "action", name: "Action" },
  { id: "call", name: "Call" },
  { id: "on_site_appointment", name: "On-Site Appointment" },
  { id: "virtual_appointment", name: "Virtual Appointment" },
  { id: "chat", name: "Chat" },
  { id: "email", name: "Email" },
];


const stateTags = {
  planned: "amber",
  rescheduled: "rose",
  done: "lime",
};

const getAgent = async () => {
  const session = getStorage("ctxSession");
  const dom = [["user", "=", session.user]];
  const fields = ["id", "rec_name"];
  const { data } = await proxy.search("commission.agent", dom, fields, 1);
  return data?.[0];
};

function layout() {
  const ctxView = {
    model: "crm.activity",
    form_action: ["add", "edit"],
    table_action: ["add", "edit"],
    target: "opportunity",
    limit: 50,
    fields: {
      customer: {
        type: "many2one",
        model: "crm.prospect",
        readOnly: true,
      },
      subject: {
        type: "char",
      },
      type_info: {
        type: "char",
      },
      state: {
        type: "char",
        tags: stateTags,
        readOnly:true
      },
      description: {
        type: "text",
      },
      planned_time: {
        type: "datetime",
      },
      planned_date: {
        type: "date_2",
        required: true,
      },
      duration: {
        type: "integer",
      },
      effective_date: {
        type: "date_2",
      },
      type_: {
        type: "selection",
        options: TYPES_LEADS,
        translate: true,
        required: true,
      },
      agent: {
        type: "many2one",
        model: "commission.agent",
        default: getAgent,
        searchable: true,
      },
      opportunity: {
        type: "many2one",
        model: "crm.opportunity",
        readOnly: true,
        searchable: true,
      },
    },
    list: [
      { name: "type_", width: "30%" },
      { name: "planned_date", width: "30%" },
      { name: "duration", width: "30%" },
      { name: "state", width: "30%", widget: "circle" },
    ],
    form: [
      { name: "customer" },
      {
        name: "block1",
        type: "grid",
        cols: "grid-cols-2",
        colSpan: "col-span-1",
        elements: [{ name: "opportunity" }, { name: "state" }],
      },
      { name: "agent" },
      { name: "subject" },
      { name: "type_" },
      {
        name: "dates",
        type: "grid",
        cols: "grid-cols-3",
        colSpan: "col-span-1",
        elements: [
          { name: "planned_date" },
          { name: "effective_date" },
          { name: "duration" },
        ],
      },
      {
        name: "description",
        type: "grid",
        cols: "grid-cols-1",
        elements: [{ name: "description" }],
      },
    ],
  };
  return ctxView;
}
export { layout };
